import React, { Component } from 'react'
import {
  Title, Field, Label, Control, Input, Button, Notification, Delete, Help
} from 'bloomer'

import { gql } from 'apollo-boost'
import { Mutation } from 'react-apollo'


const CHANGE_PASSWORD = gql`
  mutation ($oldPassword: String!, $newPassword: String!, $confirmNewPassword: String!) {
    changePassword (oldPassword: $oldPassword, newPassword1: $newPassword, newPassword2: $confirmNewPassword) {
      user { id }
    }
  }
`

class AccountForm extends Component {
  state = {
    oldPassword: {
      value: '',
      error: ''
    },
    newPassword: {
      value: '',
      error: ''
    },
    confirmNewPassword: {
      value: '',
      error: ''
    },
    feedback: null
  }

  validateNotEmpty = (key, message) => {
    const { value } = this.state[key]

    if (value.trim() === '') {
      this.setState(() => ({
        [key]: {
          ...this.state[key],
          error: message
        }
      }))
      return false
    }

    this.setState(() => ({
      [key]: {
        ...this.state[key],
        error: ''
      }
    }))
    return true
  }

  validate = () => {
    const { newPassword, confirmNewPassword } = this.state

    const fields = [
      ['oldPassword', 'Informe sua senha atual'],
      ['newPassword', 'Informe a nova senha'],
      ['confirmNewPassword', 'Confirme a nova senha']
    ]

    const cleanFields = fields.filter((args) => {
      return this.validateNotEmpty(...args)
    })

    if (cleanFields.length === fields.length) {
      if (newPassword.value === confirmNewPassword.value) {
        this.setState((state) => ({
          confirmNewPassword: {
            ...state.confirmNewPassword,
            error: ''
          }
        }))
        return true
      } else {
        this.setState((state) => ({
          confirmNewPassword: {
            ...state.confirmNewPassword,
            error: 'A confirmação não confere com a nova senha'
          }
        }))
      }
    }

    return false
  }

  clearFeedback = () => {
    this.setState(() => ({
      feedback: null
    }))
  }

  handleChange = (key) => (evt) => {
    const value = evt.target.value
    this.setState(() => ({
      [key]: {
        ...this.state[key],
        value
      }
    }))
  }

  handleSubmit = async (mutate, evt) => {
    evt.preventDefault()

    if (!this.validate()) {
      return
    }

    try {
      await mutate()
      this.setState(() => ({
        feedback: {
          type: 'success',
          message: 'Senha atualizada com sucesso.'
        }
      }))
    } catch (e) {
      console.error(e)
      this.setState(() => ({
        feedback: {
          type: 'danger',
          message: 'Não foi possível se comunicar com o servidor.'
        }
      }))
    }

  }

  render() {
    const { oldPassword, newPassword, confirmNewPassword, feedback } = this.state

    return (

      <Mutation mutation={CHANGE_PASSWORD} variables={{
        oldPassword: oldPassword.value,
        newPassword: newPassword.value,
        confirmNewPassword: confirmNewPassword.value
      }}>
      {(mutate, {loading}) => (
        <div>
          <Title isSize={3}>Alterar senha</Title>

          {feedback && <Notification isColor={feedback.type}><Delete onClick={this.clearFeedback}/> {feedback.message}</Notification>}

          <form onSubmit={this.handleSubmit.bind(this, mutate)}>
            <Field>
              <Label>Senha atual</Label>
              <Control>
                <Input
                  type="password"
                  placeholder="Senha atual"
                  value={oldPassword.value}
                  isColor={oldPassword.error ? 'danger' : ''}
                  onChange={this.handleChange('oldPassword').bind(this)}
                />
                {oldPassword.error && <Help isColor="danger">{oldPassword.error}</Help>}
              </Control>
            </Field>

            <Field>
              <Label>Nova senha</Label>
              <Control>
                <Input
                  type="password"
                  placeholder="Nova senha"
                  value={newPassword.value}
                  isColor={newPassword.error ? 'danger' : ''}
                  onChange={this.handleChange('newPassword').bind(this)}
                />
                {newPassword.error && <Help isColor="danger">{newPassword.error}</Help>}
              </Control>
            </Field>

            <Field>
              <Label>Confirmação da nova senha</Label>
              <Control>
                <Input
                  type="password"
                  placeholder="Confirmação da nova senha"
                  value={confirmNewPassword.value}
                  isColor={confirmNewPassword.error ? 'danger' : ''}
                  onChange={this.handleChange('confirmNewPassword').bind(this)}
                />
                {confirmNewPassword.error && <Help isColor="danger">{confirmNewPassword.error}</Help>}
              </Control>
            </Field>

            <Button type="submit" isLoading={loading}>Atualizar senha</Button>
          </form>
        </div>
      )}
      </Mutation>
    )
  }
}

export default AccountForm



// WEBPACK FOOTER //
// ./src/pages/SettingsPage/Account.js